import { CompensationHistoryInterface } from '../models/history';
import { FIELD_NAMES } from './common';
import { Field, ValidationError } from '../models/home';

export const DEFAULT_BOOKING_INFORMATION_FIELDS: Field[] = [
    {name: FIELD_NAMES.bookingReference, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.ticketNumber, value: '', error: '', requiredError: ''}
];

export const DEFAULT_COMPENSATION_FIELDS: Field[] = [
    {name: FIELD_NAMES.reasonId, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.categoryId, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.cabinId, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.compensationNum, value: '1', error: '', requiredError: '', disabled: false},
    {name: FIELD_NAMES.comments, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.compensationType, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.wifiRegion, value: '', error: '', requiredError: ''}
];

export const DEFAULT_COMPENSATION_VOUCHERS = {
    compensationVouchers: [
        {
            code: '',
            type: '',
            used: false,
            user: {
                firstName: '',
                lastName: '' 
            }
        }
    ],
    distributionId: ''
};

export const DEFAULT_FLIGHT_INFORMATION_FIELDS: Field[] = [
    {name: FIELD_NAMES.flightNumber, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.date, value: '', error: '', requiredError: ''}
];

export const DEFAULT_PASSENGER_INFORMATION_FIELDS: Field[] = [
    {name: FIELD_NAMES.firstName, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.lastName, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.email, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.confirmEmail, value: '', error: '', requiredError: ''}
];

export const DEFAULT_SEARCH_INFORMATION_FIELDS: Field[] = [
    {name: FIELD_NAMES.lastName, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.date, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.bookingReference, value: '', error: '', requiredError: ''},
    {name: FIELD_NAMES.ticketNumber, value: '', error: '', requiredError: ''}
];

export const DEFAULT_SEARCH_RESULTS: CompensationHistoryInterface[] = [
    {
        bookingReference: '',
        comments: '',
        customer: '',
        date:'',
        email:'',
        error: false,
        errorMessage:'',
        flight:'',
        id: 'default',
        qty: 0,
        reason:'',
        type:'',
        subType: '',
        voucherIds: [],
    },
    {
        bookingReference: '',
        comments: '',
        customer: '',
        date:'',
        email:'',
        error: false,
        errorMessage:'',
        flight:'',
        qty: 0,
        id: 'default1',
        reason:'',
        type:'',
        subType: '',
        voucherIds: [],
    }
];

export const DEFAULT_VALIDATION_ERROR: ValidationError = {
    errorCode: 0,
    isError: false,
    successCount: 0,
    failureCount: 0
};
